export class GetAttendance {
  static readonly type = '[Attendance] Get Attendance'
  constructor(public weekNumber: number) {}
}

export class ResyncAttendance {
  static readonly type = '[Attendance] Resync Attendance'
  // Empty: every location the user has permission for.
  constructor(
    public weekNumber: number,
    public locationIds: string[]
  ) {}
}

export class EmployeeAttendanceDetails {
  static readonly type = '[Attendance] Employee Attendance Details'
  constructor(
    public employeeId: string,
    public from: Date
  ) {}
}
